/**
 * Утилиты для работы с URL и query-параметрами
 */

/**
 * Проверить наличие query-параметра
 * @param {string} param - Название параметра
 * @param {Object} route - Объект route из Vue Router
 * @returns {boolean} - true если параметр существует
 */
export const hasQueryParam = (param, route) => {
  return !!route.query[param];
};

/**
 * Получить значение query-параметра
 * @param {string} param - Название параметра
 * @param {Object} route - Объект route из Vue Router
 * @returns {string|null} - Значение параметра или null
 */
export const getQueryParam = (param, route) => {
  return route.query[param] || null;
};

/**
 * Удалить query-параметры из URL
 * @param {Array|string} params - Параметры для удаления (массив или строка)
 * @param {Object} router - Объект router из Vue Router
 * @param {Object} route - Объект route из Vue Router
 */
export const removeQueryParams = (params, router, route) => {
  const paramsArray = Array.isArray(params) ? params : [params];
  const query = { ...route.query };

  paramsArray.forEach((param) => {
    delete query[param];
  });

  router.replace({ ...route, query });
};

/**
 * Получить и сразу удалить query-параметр
 * @param {string} param - Название параметра
 * @param {Object} router - Объект router из Vue Router
 * @param {Object} route - Объект route из Vue Router
 * @returns {string|null} - Значение параметра перед удалением
 */
export const getAndRemoveQueryParam = (param, router, route) => {
  const value = getQueryParam(param, route);
  removeQueryParams(param, router, route);
  return value;
};
